import axios from 'axios';
import React, { useEffect, useState } from 'react'
 import { Link } from 'react-router-dom';
import { useNavigate, useParams } from "react-router-dom";
// import { CSVLink } from 'react-csv';
 import { Card, CardBody, Table } from 'react-bootstrap';
import { BASE_URL } from './APi';
import { IoMdSearch } from 'react-icons/io';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';

export const StaffTableComponents = ({ head, axiostabledata, Edit, View, Add,title,Create,Sumofkeys,warehousehdata}) => {
  const { id } = useParams();
  const navigate = useNavigate();


  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(encodeURIComponent(' '));
  const [number, setnumber] = useState([])
  const [total, setotal] = useState([])
  const [size, setsize] = useState([])
  const [getid, setgetid] = useState(0)
  const [limit, setlimit] = useState(10)
  const [sort1, setsort1] = useState(false)
  const [sort, setsort] = useState("asc")
  const [fieldnme, setfeilds] = useState("id")
  const [data, setdata] = useState([])
  const [superid, setsuperid] = useState(0)
  const [exportpage, setexport] = useState([])
  const [data1, setdata1] = useState(10)
  const [entries, setentries] = useState([])
  const { pointindex } = useParams();
  const [loading, setLoading] = useState(false);
  const pagination = (msg) => {
    setgetid(msg)
  }
  const handlechange = (entry) => {
    setdata1(entry)
    setlimit(entry)
  }

  const count = [{ "value": 10 }, { "value": 20 }, { "value": 30 }, { "value": 50 }]
const [searchValue, setSearchValue] = useState('');

  const searchhandle = (search) => {
    // if (search.length == 0) {
      // setError(encodeURIComponent(' '))
      setSearchValue(search)
    // } else {
      // setError(search)tgtg


    // }
  }

  const handlesort = (field) => {
    setsort1(!sort1)
    if (sort1) {
      setsort("asc")
      setfeilds(field)
    } else {
      setsort("desc")
      setfeilds(field)
    }

 

  }

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem('staffToken');
    const startTime = new Date().getTime();
    axios
    .get(
      `${BASE_URL}/${axiostabledata}/page/${Number(currentPage) - 1}/${Number(limit)}/${sort}/${fieldnme}/${error}`, 
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('staffToken') }
      }
    )
    .then(response => {
      setLoading(false);
      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;
      // console.log(`Request took ${elapsedTime} milliseconds`);
      setentries(response.data.Enteries);
      // console.log(response);
      if (response.data.Index === undefined) {
        setsize(0);
        setnumber(0);
        // console.log(response);
        setdata(response.data.data);
      } else {
        setsize(response.data.Pages);
        setnumber(response.data.Pages);
        setdata(response.data.Index);
      }
    })
    .catch(error => {
      setLoading(false);
      console.error(error);
    });
  }, [getid, limit, fieldnme, sort,currentPage,error]);


  const data5 = Object.assign(...Sumofkeys.map(({ first }) => ({
    [first]: data.reduce((acc, curr) => acc + (parseFloat(curr[first]) || 0), 0)
})));

// console.log(data5);
  // c 


  const handle = (id) => {
    // console.log(id)
    if(axiostabledata!=="myorder"){
    if (id >= 0) {
       if(Number(pointindex)==0){
      navigate(`${Edit}/${id}/${Number(currentPage)}`)}else{
        navigate(`${Edit}/${id}/${currentPage}`)
      }
    } else {
      if(Number(pointindex)==0){
        navigate(`${View}/${id.view}/${Number(currentPage)}`)}else{
          navigate(`${View}/${id.view}/${currentPage}`)
        }
    }
  }

  }
  const bruce = data.map((item, rowIndex) => (
    <tr className="the"  >
      {head.map((item2) =>
       
        <td className="datatabletd"  style={{display:item2.field=="action"?axiostabledata=="mininmumstock" ? "none" : "block":""}} onClick={() => { handle(item2.field == "action" ? { "view": item.id } : item.id); }}>{item2.field == "action" ? item2.subaction1 : item[item2.field]}</td>
      )}
    </tr>
  ));
  useEffect(() => {
    // console.log(currentPage)
      setCurrentPage(Number(pointindex))
    setgetid(Number(pointindex))

  }, [])

  const handlePageChange = (page) => { 
    setCurrentPage(page);
 
    setsuperid(page - 1);
    pagination(page - 1);
  };
  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;

    for (let i = Math.max(1, currentPage - 2); i <= Math.min(number - 1, currentPage + 1); i++) {
      pages.push(
        <li key={i} className={i===Number(currentPage) ? 'newway' : ''} onClick={() => handlePageChange(i)}>
          {i}
        </li>
      );
    }
    // pages+1
    return pages;
  };
  useEffect(() => {
  const delayDebounce = setTimeout(() => {
    setError(searchValue.trim().length === 0 ? encodeURIComponent(' ') : encodeURIComponent(searchValue));
  }, 1000); // Wait 500ms before setting error

  return () => clearTimeout(delayDebounce); // Clear on every new keystroke
}, [searchValue]);
 return (
  <>
    <Card
      style={{
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
        borderRadius: '24px',
        border: 'none',
        background: '#fff',
        // maxWidth: 1200,
        width: '100%',
      }}
    >
      <Card.Header
        style={{
          background: '#fff',
          color: '#222',
          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '18px 24px',
          height: '64px',
        }}
      >
        <h1
          style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            margin: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '60vw',
          }}
        >
          {title}
        </h1>

        {Create?.length ? (
          <Link to={Create}>
            <button
              className="button-70"
              style={{
                display: axiostabledata === 'erfedf' ? 'none' : 'block',
                background: '#222',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '1rem',
                padding: '8px 22px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
              }}
            >
              {Add}
            </button>
          </Link>
        ) : null}
      </Card.Header>

      <CardBody>
        <div
          className="forentriesandaddbutton"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
          }}
        >
          <div className="bottole" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <p style={{ margin: 0, color: '#222', fontWeight: 500 }}>Show entries</p>
            <select
              className="newselect"
              style={{ borderRadius: 8, border: '1px solid #e5e7eb', padding: '4px 12px' }}
              onChange={(e) => handlechange(e.target.value)}
              value={data1}
            >
              {count.map((item) => (
                <option key={item.value}>{item.value}</option>
              ))}
            </select>
          </div>

          <div className="search" style={{ position: 'relative', width: 220 }}>
            <IoMdSearch
              style={{ position: 'absolute', left: '10px', top: '14px' }}
              color="#888"
              size="1.4em"
            />
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => searchhandle(e.target.value)}
              style={{
                borderRadius: 8,
                border: '1px solid #e5e7eb',
                padding: '6px 12px 6px 36px',
                width: '100%',
              }}
            />
          </div>
        </div>

        <Table
          responsive
          className="custom-table"
          style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          }}
        >
          <thead>
            <tr>
              {head.map((headItem, index) => (
                <th
                  key={index}
                  style={{
                    display:
                      headItem.field === 'action' && axiostabledata === 'mininmumstock'
                        ? 'none'
                        : 'table-cell',
                  }}
                  onClick={() =>
                    handlesort(headItem.field === 'action' ? 'id' : headItem.field)
                  }
                  className="table-header"
                >
                  {headItem.label}
                  {sort1 ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={head.length} style={{ textAlign: 'center', padding: 40 }}>
                  <div
                    className="spinner-border text-dark"
                    style={{ width: 50, height: 50, borderWidth: 6 }}
                    role="status"
                  />
                </td>
              </tr>
            ) : (
              bruce
            )}
          </tbody>
        </Table>

        <div
          className="flex"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 24,
          }}
        >
          <div className="showentri" style={{ color: '#222', fontWeight: 500 }}>
            {entries > 0 && (
              <p>
                Showing {superid * data1 + 1} to{' '}
                {Math.min(superid * data1 + parseInt(data1), entries)} of {entries} entries
              </p>
            )}
          </div>

          <div className="pagination">
            <ul
              className="pagination"
              style={{
                display: 'flex',
                gap: 8,
                listStyle: 'none',
                margin: 0,
                padding: 0,
              }}
            >
              <li
                style={{
                  cursor: 'pointer',
                  color: '#222',
                  fontWeight: 600,
                  borderRadius: 6,
                  padding: '4px 12px',
                  background: '#f3f4f6',
                }}
                onClick={() =>
                  handlePageChange(currentPage > 1 ? currentPage - 1 : 1)
                }
              >
                Previous
              </li>
              {renderPageNumbers()}
              <li
                style={{
                  cursor: 'pointer',
                  color: '#222',
                  fontWeight: 600,
                  borderRadius: 6,
                  padding: '4px 12px',
                  background: '#f3f4f6',
                }}
                onClick={() =>
                  handlePageChange(currentPage === number ? number : currentPage + 1)
                }
              >
                Next
              </li>
            </ul>
          </div>
        </div>
      </CardBody>
    </Card>
  </>
);

}